import React, { PropTypes } from 'react'

import css from './style.scss'

const AccountHeading = ({ children }) => (
  <h2 className={css.accountHeading}>
    {children}
  </h2>
)

AccountHeading.propTypes = {
  children: PropTypes.string
}

export default AccountHeading
